<template>
  <div class="am-conversion-popup">
    <div>
      <div class="am-conversion-title-bar am-main-top-box">
        <span class="am-conversion-title am-main-top-box-title"><strong>Add Conversion</strong></span>
      </div>
      <table class="am-conversion-table">
        <tbody>
        <tr>
          <td><strong><span>Type:</span><span class="am-asterisk-validation">&nbsp;*</span></strong></td>
          <select class="am-al3-dropdown" v-model="selectedType" @change="competitortypeDropdown">
            <option  value="" selected>- Select Type -</option>
            <option  value="AL3" >AL3</option>
            <option  value="Competitor" >Competitor</option>
          </select>
        </tr>
        <tr v-if="competitorDropDown">
          <td><strong><span>Competitor System:</span><span class="am-asterisk-validation">&nbsp;*</span></strong></td>
          <select class="am-al3-dropdown" v-model="selectedSystem" @change="systemShow()">
            <option value="" selected>- Select Competitor System -</option>
            <option v-for="competitor in competitorList" :value="competitor.id" :key="competitor.id">{{competitor.name}}</option>
          </select>
        </tr>
        <tr v-if="competitorSystem">
          <td><strong><span>Competitor System Name:</span><span class="am-asterisk-validation">&nbsp;*</span></strong></td>
          <td>
            <input type="text" id="CompetitorSystem" class="am-conversion-name input" v-model="conversion.competitorName">
          </td>
        </tr>
        <tr v-if="company">
          <td><strong><span>Company:</span><span class="am-asterisk-validation">&nbsp;*</span></strong></td>
          <td>
            <input type="text"  id="company" class="am-conversion-name input" v-model="conversion.competitorName">
          </td>
        </tr>
        <tr>
          <td><strong><span>Conversion fee:</span></strong></td>
          <td>
            <money class="input" id="conversionFee" v-model="conversion.fee" v-bind="money"></money>
          </td>
        </tr>
        <tr>
          <td><strong><span>Comments:</span></strong></td>
          <td>
            <textarea class="am-comments" id="comments" rows="4" cols="30" v-model="conversion.comments" maxlength="500"></textarea>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="am-conversion-blue-border"></div>
      <div class="am-conversion-align-bottom-buttons">
        <div class="am-conversion-float-left">
          <button type="button" class="btn btn-primary" @click="submit()">Submit</button>
          <button type="button" class="btn btn-secondary" @click="closeModal()">Cancel</button>
        </div>
      </div>
    </div>
    <modal name="AddConversionPopUp" classes="am-vue-modal" :clickToClose="false" height="auto" width="370px" :scrollable="true"  :pivotY="0.5" :adaptive="true">
      <message-popup :confirmDelete="false" modal-name="AddConversionPopUp" :errors="messageString" messageHeader="Error"></message-popup>
    </modal>
  </div>
</template>

<script>
  import api from './../http'
  import config from './../config/global.config'
  import MessagePopup from "./MessagePopup"
  import { Money, VMoney } from 'v-money'

  export default {

  data() {
  return {
    name: "ConversionModal",
    conversion: {
      employeeId: this.$store.state.auth.user.id,
      competitorId: null,
      competitorName: null,
      comments: null,
      fee: 0,
      conversionType: null
    },
    money: {
      decimal: '.',
      thousands: ',',
      prefix: '$ ',
      masked: false
    },
    competitorDropDown: false,
    competitorSystem: false,
    company: false,
    selectedType: '',
    selectedSystem: '',
    messageString: '',
    competitorList: [],
    otherCompetitorId: 127
  }
  },

  props: {
    masterId: {
      type: Number,
      default: 0
    }
  },

  directives: {
    money: VMoney
  },
  methods: {
    closeModal () {
      this.$modal.hide('conversionModal')
    },
    competitortypeDropdown: function () {
    if (this.selectedType.toString() === ""){
      this.company = false;
      this.competitorDropDown = false;
      this.competitorSystem = false;
    } else if (this.selectedType.toString() === "Competitor")  {
      this.selectedSystem = '';
      this.competitorDropDown = true;
      this.company = false;
      }else{
      this.competitorDropDown = false;
      this.competitorSystem = false;
      this.company = true;
      }

    },
    systemShow: function () {
      this.competitorSystem = (this.selectedSystem === this.otherCompetitorId)
    },
    submit() {
      let self = this
      if(self.selectedType === ""){
        self.messageString = "Type is a required field.\n" +
          "Please re-check the configurations"
        self.$modal.show('AddConversionPopUp')
        return false
      } else if (self.selectedType === "Competitor" && (self.selectedSystem === "" || (self.selectedSystem === self.otherCompetitorId && (self.conversion.competitorName === null || self.conversion.competitorName.trim() === "")))) {
        self.messageString = "Competitor System is a required field.\n" +
          "Please re-check the configurations"
        self.$modal.show('AddConversionPopUp')
        return false
      } else if (self.selectedType === "AL3" && (self.conversion.competitorName === null || self.conversion.competitorName.trim() === "")) {
        self.messageString = "Company is a required field.\n" +
          "Please re-check the configurations"
        self.$modal.show('AddConversionPopUp')
        return false
      } else {
        if(self.selectedType === "Competitor" && self.selectedSystem !== ""){
          self.conversion.competitorId = parseInt(self.selectedSystem)
        }
        self.conversion.conversionType = self.selectedType
      }
      self.conversion.fee = Math.abs(self.conversion.fee)
      self.conversion.masterId = self.masterId
      api.postRequest('backoffice/conversion/add', self.conversion).then(
        () => {
          window.location.reload()
          self.closeModal()
        }
      ).catch(
        () => {
          self.messageString = "An error occurred while adding a Conversion.\n" +
            "Please re-check the configurations"
          self.$modal.show('AddConversionPopUp')
        }
      )},

    findCompetitors() {
      let self = this
      api.makeRequest('backoffice/conversion/' + self.$store.state.auth.user.id + '/competitor/get').then(
        (data) => {
         return self.competitorList = data.data.results
        }
      ).catch(
        () => {
          return self.competitorList = []
        }
      )
    }
  },
    components: {
      MessagePopup,
      Money
    },
    mounted () {
     this.findCompetitors()
    },
}
</script>

<style scoped>
  .am-conversion-popup{
    width: 100%;
  }
  .am-main-top-box{

    padding: 8px;
  }
  .am-main-top-box-title{
    font-size: 12px;
  }
  .am-conversion-table {
    margin-top: 10px;
    margin-left: 12px;
  }
  .am-conversion-table td input{
    background-color: white;
    margin: 2px 0px 1px 50px;
    width: 150px;
    max-width: 250px;
  }
  #conversionFee{
    width: 96px;
  }
  .am-al3-dropdown {
    margin: 3px 0px 1px 51px;
    background-color: white;
    max-width: 250px;
    width: 190px;
    height: 22px;
  }
  .am-comments {
    margin: 2px 0px 0px 50px;
    background-color: white;
    max-width: 325px;
    max-height: 150px;
  }
  .am-conversion-blue-border{
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 15px;
  }
  .am-conversion-align-bottom-buttons {
    padding: 5px 7px 9px 0px;
    float: right;
  }
  .btn-primary{
    padding: 2px 10px;
    font-size: 12px;
    margin-right: 5px;
  }
  .btn-secondary{
    padding: 2px 10px;
    font-size: 12px;
    margin-right: 3px;
  }
  .am-asterisk-validation {
    color: #ff0000;
    font-weight: 700;
    font-size: 16px;
  }
  .am-conversion-name {
    width: 190px !important;
  }
</style>
